import React from 'react';
import { Link } from 'react-router-dom';

const Service = () => {
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero start */}
      <div 
        className="inner-page-hero" 
        style={{ backgroundImage: 'url(/assets/images/background/bg3.png)' }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>Service</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">Service</Link></li>
          </ul>
        </div>
      </div>
      {/* inner-page hero end */}

        {/* Services Three */}
      <div className="services-three">
        <div className="services-three-shape-one-1"><img alt="shape" src="/assets/images/shape/services-three-shape-1.png" /></div>
        <div className="services-three-shape-one-2"><img alt="shape" src="/assets/images/shape/services-three-shape-2.png" /></div>
        <div className="container">
          <div className="heading-box text-center">
            <span className="heading-subtitle wow fadeInUp animated animated">🤝 OUR SERVICES</span>
            <h2 className="heading-title wow fadeInUp animated animated">Explore Our Comprehensive Services</h2>
          </div>
          <div className="row gutter-y-40">
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-personal"></i></div>
                <hr />
                <span>01</span>
                <div className="services-three-box-title"><h3>Offer Financial Flexibility</h3></div>
                <div className="services-three-box-info"><p>A selection of customized loan choices intended to quickly handle unforeseen financial difficulties. Our loans are designed to be helpful and flexible, meeting a range of unexpected needs with ease and confidence.</p></div>
             {/*    <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-money-bag"></i></div>
                <hr />
                <span>02</span>
                <div className="services-three-box-title"><h3>Loan for debt Consolidation</h3></div>
                <div className="services-three-box-info"><p>Managing several financial responsibilities is made easier with Loanintap's debt consolidation loan. Reduce the strain of high-interest debt by combining all of your payments into one easy-to-pay installment each month.</p></div>
                {/* <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-mortgage-loan"></i></div>
                <hr />
                <span>03</span>
                <div className="services-three-box-title"><h3>Loan for Quick Purchasing</h3></div>
                <div className="services-three-box-info"><p>Take advantage of Loanintap's quick financing options to grab lucrative possibilities and exclusive offers. Get quick access to money for necessary or desirable purchases, so you don't pass up good opportunities..</p></div>
               {/*  <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-loan-1"></i></div>
                <hr />
                <span>04</span>
                <div className="services-three-box-title"><h3>Personal Loans</h3></div>
                <div className="services-three-box-info"><p>Get instant funds for weddings, travel, medical emergencies with simple documentation, ensuring quick approval and a smooth, stress-free borrowing experience tailored to your needs.</p></div>
              {/*   <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-mortarboard"></i></div>
                <hr />
                <span>05</span>
                <div className="services-three-box-title"><h3>Loan for a Celebration</h3></div>
                <div className="services-three-box-info"><p>Use Festival Loan to enhance your unique moments without worrying. Our customised loans take the stress out of money, making special occasions like anniversaries and birthdays genuinely memorable.</p></div>
             {/*    <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="services-three-box">
                <div className="services-three-box-icon"><i className="flaticon-money-bag-1"></i></div>
                <hr />
                <span>06</span>
                <div className="services-three-box-title"><h3>Loan for Home Improvement</h3></div>
                <div className="services-three-box-info"><p>With home improvement loans, you can turn your living area into your ideal house, whether they are improvements to elevate your surroundings, renovations to create a peaceful retreat, or necessary furnishings.</p></div>
               {/*  <a className="btn-link" href="#">Apply Now <i className="flaticon-next"></i></a> */}
              </div>
            </div>
          </div>
        </div>
      </div>


    
      
      {/* <br />
      <br /> */}
    </>
  );
};

export default Service;